export default __webpack_public_path__ + "images/c8d9896481af409f7e99fc3bb797f718.png";